"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 14.804a3.57 3.57 0 0 1 3.568-3.569h3.253a3.57 3.57 0 0 1 3.568 3.569.7.7 0 1 1-1.4 0c0-1.198-.97-2.169-2.168-2.169H6.568A2.169 2.169 0 0 0 4.4 14.804z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.7 14.104a.7.7 0 0 1 .7.7v.14a.7.7 0 1 1-1.4 0v-.14a.7.7 0 0 1 .7-.7m4.495-8.349a1.727 1.727 0 1 1 0 3.455 1.727 1.727 0 0 1 0-3.455m3.127 1.728a3.127 3.127 0 1 0-6.255 0 3.127 3.127 0 0 0 6.255 0m5.472.871a.7.7 0 0 1 .002.99l-2.48 2.489a.7.7 0 0 1-.992 0l-1.52-1.526a.7.7 0 0 1 .992-.988l1.024 1.028 1.984-1.991a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserWithCheckmarkIcon20.js.map